<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ carrier.name }}
        </h1>
        <h1>
          {{ $tc('models.service', 2) }}
          <v-btn color="primary" :disabled="(!$auth.isDev() && carrier.freeze_settings)" @click="goTo('newService', { carrierId: $route.params.carrierId })"> {{ $t('create') }} </v-btn>
          <v-btn color="primary" outline @click="goTo('carriers')"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.sequential_id || props.item.id }} </td>
            <td> {{ props.item.name }} </td>
            <td> {{ props.item.code }} </td>
            <td>
              <StatusChip :status="props.item.status" outline></StatusChip>
            </td>
            <td class="pa-0 pr-2 text-xs-right">

              <v-btn color="success" flat icon @click="activate(props.item)" v-if="props.item.status === 'suspended'">
                <font-awesome-icon icon="check"></font-awesome-icon>
              </v-btn>

              <v-btn color="red" flat icon @click="suspend(props.item)" v-if="props.item.status === 'active'">
                <font-awesome-icon icon="ban"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat icon v-if="props.item.service_type=='zonal'"  @click="goTo('serviceZones', { serviceId: props.item.id })">
                <font-awesome-icon icon="map-marker"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat icon v-else-if="props.item.service_type=='international'"  @click="goTo('serviceCountries', { serviceId: props.item.id })">
                <font-awesome-icon icon="map-marker"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat icon v-else  @click="goTo('servicePostalCodes', { serviceId: props.item.id })">
                <font-awesome-icon icon="map-marker"></font-awesome-icon>
              </v-btn>


               <v-btn v-if="(props.item.provider_name === 'Estafeta' || props.item.service_type!='international') && ( (props.item.service_type == 'national' && !props.item.use_quoted_rates) || (props.item.service_type == 'national' && props.item.use_quoted_rates && props.item.use_static_rates) || (props.item.service_type == 'zonal') )" color="primary" flat icon @click="goTo('servicePrices', { serviceId: props.item.id })">
                <font-awesome-icon icon="hand-holding-usd"></font-awesome-icon>
              </v-btn>

              <v-btn color="primary" flat icon @click="goTo('editService', { carrierId: $route.params.carrierId, id: props.item.id })">
                <font-awesome-icon icon="edit"></font-awesome-icon>
              </v-btn>

              <v-btn color="red" flat icon @click="destroy(props.item)" v-if="$auth.isDev()">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>

            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
import Service from '@/client/service'

export default {
  name: 'ServicesView',

  props: {},

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'id', width: '5%' },
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.code'), align: 'left', sortable: true, value: 'code' },
        { text: this.$t('attrs.status'), align: 'left', sortable: true, value: 'status' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      loading: false,
      carrier: {}
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      this.items = await Service.all({
        where: {
          carrier_id: this.carrier.id
        },
        per_page: 2000
      })
      this.loading = false
    },

    async destroy (service) {
      try {
        if (this.confirmation(service)) {
          await Service.destroyById(service.id)
          this.fetch()
        }
      } catch (err) {
        this.handleErr(err)
      }
    },

    confirmation (service) {
      return window.confirm(this.$t('deleteConfirmation', { name: service.name, obj: this.$tc('models.service', 1).toLowerCase() }))
    },

    async activate (service) {
      try {
        service.status = 'active'
        await service.save()
      } catch (err) {
        // empty
      }
      await this.fetch()
    },

    async suspend (service) {
      try {
        service.status = 'suspended'
        await service.save()
      } catch (err) {
        // empty
      }
      await this.fetch()
    },
  },

  watch: {
  },

  async mounted () {
    this.carrier = await Carrier.findOne(this.$route.params.carrierId)
    this.fetch()
  }
}
</script>
